module.exports = __webpack_public_path__ + "static/media/9.4692687e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/9.png
// module id = 1289
// module chunks = 0